module.exports = __webpack_public_path__ + "static/img/16.30a3b3fa.png";